import { Stack } from '@mui/material'
import ReCAPTCHA from 'react-google-recaptcha'
import { useSelector } from 'react-redux'
import { IRecaptchaToken, IReducer } from 'src/interface'

interface IRecaptchaProps {
  onChange: (token: IRecaptchaToken) => void
  theme?: 'light' | 'dark'
}

const isTest = process.env.REACT_APP_is_test === 'true'

const Recaptcha = ({ onChange, theme = 'dark' }: IRecaptchaProps) => {
  const siteKey = useSelector((state: IReducer) => state.recaptchaReducer)
  if (isTest || !siteKey) return null
  return (
    <Stack justifyContent='center' alignItems='center' marginBottom={3}>
      <ReCAPTCHA sitekey={siteKey} onChange={onChange} theme={theme} />
    </Stack>
  )
}

export default Recaptcha
